import { Feature } from 'ol';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';

export default {
  methods: {
    isCustomLayerAdded(id) {
      return this.getLayerById(id) ? true : false;
    },
    clearCustomLayer(id) {
      if (this.isCustomLayerAdded(id)) {
        this.getLayerById(id)
          .getSource()
          .clear();
      }
    },
    customLayerAddFeatures(features, id) {
      if (this.isCustomLayerAdded()) {
        this.getLayerById(id)
          .getSource()
          .addFeatures(features);
      }
    },
    addCustomLayer(geometry, id, layerParams = {}) {
      const featureFromGeom = geometry ? [new Feature({ geometry: geometry })] : [];
      if (this.isCustomLayerAdded(id)) {
        this.clearCustomLayer(id);
        this.customLayerAddFeatures(featureFromGeom, id);
      } else {
        const newLayer = new VectorLayer({
          id,
          isSpecial: true,
          zIndex: layerParams.zIndex || 999,
          opacity: layerParams.opacity || 1,
          source: new VectorSource({
            features: featureFromGeom,
          }),
          ...(layerParams.style && {
            style: feature => [
              ...(typeof layerParams.style === 'function' ? layerParams.style(feature) : [layerParams.style].flat()),
              ...(layerParams.drawPointMarker ? [this.getMarkerStyle()] : []),
            ],
          }),
        });
        this.map.addLayer(newLayer);
      }
    },
  },
};
